import { Injectable, EventEmitter } from '@angular/core';    
import { Subscription } from 'rxjs/internal/Subscription';    
    
@Injectable({    
  providedIn: 'root'    
})    
export class RefreshNotificationService {    
    
    invokeRefreshNotification = new EventEmitter();    
    subsVar: Subscription;    
    
  constructor() { }    
    
  notificationUpdate() {    
    this.invokeRefreshNotification.emit();    
  }    

}    